export default "__VITE_ASSET__Ccl6aUw6__"